// extracted by mini-css-extract-plugin
export var deleteModal = "_qz-0";